"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var styles = __importStar(require("./InputMaskNumber.module.css"));
var react_input_mask_1 = __importDefault(require("react-input-mask"));
var InputMaskNumber = (function (_super) {
    __extends(InputMaskNumber, _super);
    function InputMaskNumber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputMaskNumber.prototype.render = function () {
        var _a = this.props, id = _a.id, json_data = _a.json_data, onChange = _a.onChange, type = _a.type, placeholder = _a.placeholder, disabled = _a.disabled, errors = _a.errors, mask = _a.mask, classNameWrap = _a.classNameWrap, className = _a.className;
        var value = json_data[id] || "";
        var error = errors[id];
        var css = styles.root + " " + className;
        if (error) {
            css = css + " " + styles.rootError;
        }
        return (React.createElement("div", { className: classNameWrap },
            React.createElement(react_input_mask_1.default, { className: css, mask: mask, value: value, onChange: function (event) {
                    onChange(id, event.target.value);
                }, placeholder: placeholder }),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    InputMaskNumber.defaultProps = {
        type: "text",
        errors: {}
    };
    return InputMaskNumber;
}(react_1.Component));
exports.InputMaskNumber = InputMaskNumber;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5wdXRNYXNrTnVtYmVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvY29tcG9uZW50cy9JbnB1dE1hc2tOdW1iZXIvSW5wdXRNYXNrTnVtYmVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLCtCQUErQjtBQUUvQixtRUFBc0Q7QUFDdEQsc0VBQXdDO0FBZXhDO0lBQXFDLG1DQUFvQjtJQUF6RDs7SUEyQ0EsQ0FBQztJQXJDVSxnQ0FBTSxHQUFiO1FBQ1UsSUFBQSxlQVdRLEVBVlYsVUFBRSxFQUNGLHdCQUFTLEVBQ1Qsc0JBQVEsRUFDUixjQUFJLEVBQ0osNEJBQVcsRUFDWCxzQkFBUSxFQUNSLGtCQUFNLEVBQ04sY0FBSSxFQUNKLGdDQUFhLEVBQ2Isd0JBQ1UsQ0FBQTtRQUVkLElBQU0sS0FBSyxHQUFHLFNBQVMsQ0FBQyxFQUFFLENBQUMsSUFBSSxFQUFFLENBQUE7UUFDakMsSUFBTSxLQUFLLEdBQUcsTUFBTSxDQUFDLEVBQUUsQ0FBQyxDQUFBO1FBRXhCLElBQUksR0FBRyxHQUFNLE1BQU0sQ0FBQyxJQUFJLFNBQUksU0FBVyxDQUFBO1FBQ3ZDLElBQUksS0FBSyxFQUFFO1lBQ1AsR0FBRyxHQUFNLEdBQUcsU0FBSSxNQUFNLENBQUMsU0FBVyxDQUFBO1NBQ3JDO1FBRUQsT0FBTyxDQUNILDZCQUFLLFNBQVMsRUFBRSxhQUFhO1lBQ3pCLG9CQUFDLDBCQUFTLElBQ04sU0FBUyxFQUFFLEdBQUcsRUFDZCxJQUFJLEVBQUUsSUFBSSxFQUNWLEtBQUssRUFBRSxLQUFLLEVBQ1osUUFBUSxFQUFFLFVBQUMsS0FBSztvQkFDWixRQUFRLENBQUMsRUFBRSxFQUFFLEtBQUssQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUE7Z0JBQ3BDLENBQUMsRUFDRCxXQUFXLEVBQUUsV0FBVyxHQUMxQjtZQUNELEtBQUssSUFBSSwyQkFBRyxTQUFTLEVBQUUsTUFBTSxDQUFDLEtBQUs7Z0JBQUcsS0FBSztvQkFBTSxDQUNoRCxDQUNULENBQUE7SUFDTCxDQUFDO0lBekNhLDRCQUFZLEdBQUc7UUFDekIsSUFBSSxFQUFFLE1BQU07UUFDWixNQUFNLEVBQUUsRUFBRTtLQUNiLENBQUE7SUF1Q0wsc0JBQUM7Q0FBQSxBQTNDRCxDQUFxQyxpQkFBUyxHQTJDN0M7QUEzQ1ksMENBQWUifQ==